import Vue from "vue";
import format from "date-fns/format";
import addHours from "date-fns/add_hours";
import idLocale from "date-fns/locale/id";

Vue.filter("toTitleCase", function(value) {
  var splitStr = value.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
});

Vue.filter("toUppercase", function(value) {
  var uppercaseValue = value.toUpperCase();
  return uppercaseValue;
});

Vue.filter("formatTime", function(value) {
  if (value) {
    const parts = value.split(":");
    return +parts[0] + ":" + parts[1] + "";
  } else {
    return "00:00";
  }
});

Vue.filter("truncate", function(value, limit) {
  if (value.length > limit) {
    value = value.substring(0, limit - 3) + "...";
  }

  return value;
});

Vue.filter("toDT", value => {
  const formatTanggal = "dddd, DD-MM-YYYY HH:mm";
  if (!value) return "";
  if (value === "-") return value;

  // Deteksi zona waktu client (berdasarkan device)
  const clientOffset = new Date().getTimezoneOffset() / 60; // WIB=-7, WITA=-8, WIT=-9

  // === PARSING AMAN ===
  // Kalau backend kirim "YYYY-MM-DD HH:mm:ss", ubah jadi ISO + WIB
  let s = String(value).trim();

  // kalau belum ada timezone info, kita anggap WIB (+07:00)
  const hasTZ = /([zZ]|[+\-]\d{2}:\d{2})$/.test(s);
  if (!hasTZ) {
    s = s.replace(" ", "T") + "+07:00";
  } else {
    s = s.replace(" ", "T");
  }

  const d = new Date(s);
  if (isNaN(d.getTime())) return "";

  // Karena d sudah absolute time (diasumsikan WIB), format() otomatis tampil sesuai timezone device
  const out = format(d, formatTanggal, { locale: idLocale });

  // suffix label zona waktu (sesuai device)
  if (clientOffset === -9) return out + " WIT";
  if (clientOffset === -8) return out + " WITA";
  return out + " WIB";
});

Vue.filter("toD", value => {
  if (!value) return "";
  if (value == "-") return value;
  return format(value, "dddd, DD-MM-YYYY", {
    locale: idLocale
  });
});
Vue.filter("toSD", value => {
  if (!value) return "";
  if (value == "-") return value;
  return format(value, "DD-MM-YYYY", {
    locale: idLocale
  });
});
Vue.filter("toSDN", value => {
  if (!value) return "";
  if (value == "-") return value;
  return format(value, "DD MMM YYYY", {
    locale: idLocale
  });
});

Vue.filter("toC", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("in-ID", {
    // style: 'currency',
    // currency: 'IDR',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter("toF2", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  return +value.toFixed(2);
});

Vue.filter("toSubstr", function(value) {
  if (!value) return "-";
  return value.toString().substring(0, 30);
});

Vue.filter("toSubstrLong", function(value) {
  if (!value) return "-";
  return value.toString().substring(0, 50);
});

Vue.filter("toStringC", function(value) {
  if (!value) return "-";
  let stringOr = value.replace(/or/gi, " atau ");
  let stringAnd = stringOr.replace(/and/gi, " dan ");
  return stringAnd;
});

Vue.filter("toStr", function(value) {
  if (Array.isArray(value)) {
    return value.toString();
  } else {
    return value;
  }
});

Vue.filter("kelaminStr", value => {
  switch (value) {
    case "L":
      return "Laki-laki";
    case "P":
      return "Perempuan";
    default:
      return "";
  }
});

Vue.filter("statusStr", value => {
  switch (+value) {
    case 0:
      return "Belum aktivasi";
    case 1:
      return "aktif";
    case 2:
      return "non-aktif";
    default:
      return "";
  }
});
